import { createAction } from '@reduxjs/toolkit';

import { errorPayloadCreator, getPayloadCreator } from 'app-components/flux/core/actionHelpers';

import type { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';
import type { SubscriptionProps, UpdateSubscriptionRenewalFrequencyPayload } from './subscriptionsTypes';

export const getSubscriptions = createAction('GET_SUBSCRIPTIONS', getPayloadCreator());
export const getSubscriptionsSuccess = createAction(
  'GET_SUBSCRIPTIONS_SUCCESS',
  getPayloadCreator<QcsSyncResourcesPayload<SubscriptionProps>>(),
);
export const getSubscriptionsFailure = createAction('GET_SUBSCRIPTIONS_FAILURE', errorPayloadCreator);

export const updateSubscriptionRenewalFrequency = createAction(
  'UPDATE_SUBSCRIPTION_RENEWAL_FREQUENCY',
  getPayloadCreator<UpdateSubscriptionRenewalFrequencyPayload>(),
);
export const updateSubscriptionRenewalFrequencySuccess = createAction(
  'UPDATE_SUBSCRIPTION_RENEWAL_FREQUENCY_SUCCESS',
  getPayloadCreator<UpdateSubscriptionRenewalFrequencyPayload | undefined>(),
);
export const updateSubscriptionRenewalFrequencyFailure = createAction(
  'UPDATE_SUBSCRIPTION_RENEWAL_FREQUENCY_FAILURE',
  errorPayloadCreator,
);
